<template>
<div class="w-100 h-100 p-relative d-flex align-items-center">
  <div class="container container-uedahiraku h-100">
    <div class="row h-100">
      <div class="col-md-6 col-lg-4 offset-lg-1 d-flex align-items-center">
        <div class="pt-4 pt-md-0">
          <h3 class="futura d-none d-md-block">ORDER<small>オーダーメイド</small></h3>
          <p>
            お好みの生き物や動物のオーダー制作を承っております。<br>
            ご相談ください。<br>
            <br>
            <small class="text-muted">
            <ul>
              <li>過去のオーダー制作例: ホッキョクグマの親子、チン、うさぎ、ネズミ、ヘビトンボ&emsp;等</li>
              <li>完成日数は１〜３ヶ月となります（時期により変更あり）</li>
              <li>フォーム記入後、運営よりご連絡させていただきます</li>
              <li>作家の承諾を得て、出版社さりげなくが一部ウェブの運営をしております。</li>
            </ul>
            </small>
          </p>
          <a href="https://forms.gle/cqhke69hh2S5xMqD9" target="_blank" class="btn btn-outline-dark font-weight-bold">ご依頼はコチラへ</a>
          <template v-if="isMobile().phone">
            <b-row class="pt-4" no-gutters>
              <b-col :cols="5">
                <img class="img-fluid" src="@/assets/images/order/2.jpg">
              </b-col>
              <b-col :cols="7">
                <img class="img-fluid" src="@/assets/images/order/3.jpg">
              </b-col>
            </b-row>
          </template>
        </div>
      </div>
      <div v-if="!isMobile().phone" class="col-md-6 col-lg-7 d-flex align-items-center">
        <div class="row no-gutters">
          <div class="col-6">
            <div class="pl-lg-5">
              <img class="img-fluid" src="@/assets/images/order/2.jpg">
            </div>
            <div class="d-none d-md-block px-md-4 px-xl-5 pt-5">
              <div class="p-lg-4 p-xl-5">
                <img class="img-fluid" src="@/assets/images/order/1.jpg">
              </div>
            </div>
          </div>
          <div class="col-6 d-flex align-items-end pb-lg-5">
            <img class="img-fluid" src="@/assets/images/order/3.jpg">            
          </div>
        </div>
      </div>
    </div>
  </div>
  <h2 class="right-title futura tracking-1">ORDER</h2>
  <div class="right-item">
    <div class="tategaki font-weight-bold">
      オーダーメイド
    </div>
  </div>
</div>
</template>

<script>
import isMobile from 'ismobilejs'

export default {
  name: 'Order',
  data() {
    return {
      isMobile,
    }
  }
}
</script>

<style lang="scss" scoped>

</style>